import { IChartInfo } from "../interfaces/chart.interface";
import { IStatistics } from "../interfaces/statistic.interface";
export function convertStatisticData(data: IChartInfo): IStatistics {
  const dailyAmout = data.DAILY.comparedTo.amount;
  const weeklyAmout = data.WEEKLY.comparedTo.amount;
  const monthlyAmout = data.MONTHLY.comparedTo.amount;

  const dailyPercentage = data.DAILY.comparedTo.percentage;
  const weeklyPercentage = data.WEEKLY.comparedTo.percentage;
  const monthlyPercentage = data.MONTHLY.comparedTo.percentage;

  return {
    DAILY: {
      id: "daily",
      label: "Today",
      value: dailyAmout,
      compared: dailyPercentage,
    },
    WEEKLY: {
      id: "weekly",
      label: "This week",
      value: weeklyAmout,
      compared: weeklyPercentage,
    },
    MONTHLY: {
      id: "monthly",
      label: "This month",
      value: monthlyAmout,
      compared: monthlyPercentage,
    },
  };
}
